<script setup>
	import { provide, ref, onMounted } from 'vue'

	import Header from './components/shell/HeaderMain.vue'
	import Footer from './components/shell/FooterMain.vue'

	const routedComponent = ref(null)

	const explorerState = ref(null);
	const userInputState = ref({
		year: false,
		geo: false
	});
	const mapDrilldownState = ref({
		dim: null,
		selectedArea: null
	})
	function updateExplorerState(url) {
		explorerState.value = url
	}

	provide('explorerState', {
		explorerState,
		updateExplorerState
	})
	provide('userInputState', {userInputState})
	provide('mapDrilldownState', {
		mapDrilldownState
	})

	/* routedComponent is the component that is currently being routed to by vue routing, which is ExplorerView.  This code is used here to store a handle to the routed component
	in global memory so that it can be referenced by directives and supporting modules.  The routedComponent is being used in this instance 
	so that the Highcharts module can invoke the updateUrlParms() and openFilter() methods defined and exposed in ExplorerView whenever a user selects/deselects a series value in a chart.
	This is a technique to handle Highchart events since we cannot add code directly to the the Highcharts library.
	*/
 	onMounted(() => {
		// Wait a tick if needed
		setTimeout(() => {
			if (routedComponent.value) {
				// Expose globally
				window.routedComponent = routedComponent.value
				console.log('routedComponent.value',routedComponent.value)
			}
		}, 0)
	})
</script>

<template>
	<div class="app-layout">
		<Header class="app-header-wrapper"/>
		<main class="app-content-wrapper">
			<router-view v-slot="{ Component }">
				<component :is="Component" ref="routedComponent" />
			</router-view>
		</main>
	</div>
		<Footer class="app-footer-wrapper"/>
	

</template>

<style scope>
	.app-layout {
		display: flex;
		flex-direction: column;
		min-height: 100vh; /* Takes full window height */
	}
	.app-header-wrapper {
		/* No fixed height required, adapts to content */
	}
	.app-content-wrapper {
		display: flex;
		flex-direction: column;
		flex-grow: 1; /* Automatically takes up all remaining vertical space */
		flex-shrink: 1;
	}
	main {
		display: flex;
		flex-shrink: 1;
		margin:1.25rem;
		gap: 1.25rem;    
	}
	.app-footer-wrapper {
		/* No fixed height required, adapts to content */
	}

	/* 499px - Mobile */
	@media (max-width: 31.1875rem) {
		main {
			margin: -1.25rem 0 0 0;
		}
	}

	@media only screen and (min-width: 769px) {
		main {
			/*display: block!important;*/
		}
	}  
</style>